/* ============================================================
   SOLIA — commerce helpers
   - Product gallery thumbnail switching
   - PDP quantity / subscription-plan selection helpers
   - Cart quantity/remove support for the native Shopify cart
   Keeps checkout native and avoids touching checkout behavior.
   ============================================================ */
(function(){
  /* ---------- shared helpers ---------- */
  function formatMoney(cents, moneyFormat){
    if(typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var value = (cents / 100).toFixed(2);
    if(!moneyFormat) return '$' + value;
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
  }

  /* ---------- PDP: gallery, qty, plan, variants ---------- */
  function initSoliaPdp(){
    document.querySelectorAll('[data-solia-pdp]').forEach(function(root){
      if(root.dataset.soliaPdpReady === 'true') return;
      root.dataset.soliaPdpReady = 'true';

      var mainImg = root.querySelector('[data-solia-gallery-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-solia-thumb]'));

      function setMainImage(src, thumb){
        if(!mainImg || !src) return;
        mainImg.setAttribute('src', src);
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        thumbs.forEach(function(t){
          t.classList.toggle('active', t === thumb);
          if(t === thumb){ t.setAttribute('aria-current', 'true'); }
          else { t.removeAttribute('aria-current'); }
        });
      }

      thumbs.forEach(function(thumb){
        thumb.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var full = thumb.getAttribute('data-full');
          if(!full){
            var img = thumb.querySelector('img');
            full = img && img.getAttribute('src');
          }
          setMainImage(full, thumb);
        });
      });

      var form = root.querySelector('[data-solia-atc]');
      var qtyVal = root.querySelector('[data-solia-qty-val]');
      var qtyInput = root.querySelector('[data-solia-qty-input]');
      var planInput = root.querySelector('[data-solia-selling-plan]');
      var sticky = document.querySelector('[data-solia-sticky]');
      var stickyAdd = sticky && sticky.querySelector('[data-solia-sticky-add]');

      function setQty(next){
        var safe = Math.max(1, parseInt(next, 10) || 1);
        if(qtyVal) qtyVal.textContent = safe;
        if(qtyInput) qtyInput.value = safe;
      }

      root.querySelectorAll('[data-solia-qty]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          var current = parseInt(qtyInput ? qtyInput.value : (qtyVal ? qtyVal.textContent : '1'), 10) || 1;
          var delta = parseInt(btn.getAttribute('data-solia-qty'), 10) || 0;
          setQty(current + delta);
        });
      });

      function setPlan(choice){
        var options = Array.prototype.slice.call(root.querySelectorAll('[data-solia-plan-choice]'));
        options.forEach(function(option){
          var isSelected = option.getAttribute('data-solia-plan-choice') === choice;
          option.classList.toggle('sel', isSelected);
          option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          if(isSelected && planInput){
            var planId = option.getAttribute('data-plan-id') || '';
            if(planId){
              planInput.disabled = false;
              planInput.value = planId;
            } else {
              planInput.value = '';
              planInput.disabled = true;
            }
          }
        });
      }

      root.querySelectorAll('[data-solia-plan-choice]').forEach(function(option){
        option.setAttribute('role', 'button');
        option.setAttribute('tabindex', '0');
        option.addEventListener('click', function(e){
          e.preventDefault();
          setPlan(option.getAttribute('data-solia-plan-choice'));
        });
        option.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' '){
            e.preventDefault();
            setPlan(option.getAttribute('data-solia-plan-choice'));
          }
        });
      });

      var selectedPlan = root.querySelector('[data-solia-plan-choice].sel');
      if(selectedPlan) setPlan(selectedPlan.getAttribute('data-solia-plan-choice'));
      setQty(qtyInput ? qtyInput.value : 1);

      /* Variant support for products that may later have multiple options. */
      var dataNode = root.querySelector('[data-solia-pdp-data]');
      var pdpData = null;
      try { pdpData = dataNode ? JSON.parse(dataNode.textContent) : null; } catch(e) { pdpData = null; }
      var variants = pdpData && Array.isArray(pdpData.variants) ? pdpData.variants : [];
      var moneyFormat = pdpData && pdpData.moneyFormat;
      var variantInput = root.querySelector('[data-solia-variant-id]');
      var priceNode = root.querySelector('[data-solia-price]');
      var oncePriceNode = root.querySelector('[data-solia-once-price]');
      var subPriceNode = root.querySelector('[data-solia-sub-price]');
      var stickyPriceNode = sticky && sticky.querySelector('[data-solia-sticky-price]');
      var addButton = root.querySelector('[data-solia-add]');
      var addLabel = root.querySelector('[data-solia-add-label]');

      function getSelectedOptions(){
        var selected = [];
        root.querySelectorAll('[data-solia-option]:checked').forEach(function(input){
          var pos = parseInt(input.getAttribute('data-solia-option'), 10) - 1;
          selected[pos] = input.value;
        });
        return selected;
      }

      function findVariant(){
        if(!variants.length) return null;
        var selected = getSelectedOptions();
        if(!selected.length) return variants[0];
        return variants.find(function(v){
          return selected.every(function(val, idx){ return !val || v.options[idx] === val; });
        }) || variants[0];
      }

      function updateVariant(){
        var variant = findVariant();
        if(!variant) return;
        if(variantInput) variantInput.value = variant.id;
        var price = formatMoney(variant.price, moneyFormat);
        var compare = variant.compare_at_price && variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, moneyFormat) : '';
        if(priceNode){
          priceNode.innerHTML = compare ? '<span style="text-decoration:line-through; color:var(--black-40); font-weight:400; margin-right:10px;">' + compare + '</span>' + price : price;
        }
        if(oncePriceNode) oncePriceNode.textContent = price;
        if(stickyPriceNode) stickyPriceNode.textContent = price;
        if(subPriceNode && variant.selling_plan_allocations && variant.selling_plan_allocations.length){
          subPriceNode.textContent = formatMoney(variant.selling_plan_allocations[0].price, moneyFormat) + '/month';
          var subChoice = root.querySelector('[data-solia-plan-choice="sub"]');
          if(subChoice){
            subChoice.setAttribute('data-plan-id', variant.selling_plan_allocations[0].selling_plan_id || (variant.selling_plan_allocations[0].selling_plan && variant.selling_plan_allocations[0].selling_plan.id) || '');
          }
        }
        var available = variant.available !== false;
        if(addButton) addButton.disabled = !available;
        if(stickyAdd) stickyAdd.disabled = !available;
        if(addLabel) addLabel.textContent = available ? 'Add to Cart' : 'Sold out';
        if(stickyAdd) stickyAdd.textContent = available ? 'Add to Cart' : 'Sold out';
        var activePlan = root.querySelector('[data-solia-plan-choice].sel');
        if(activePlan) setPlan(activePlan.getAttribute('data-solia-plan-choice'));
      }

      root.querySelectorAll('[data-solia-option]').forEach(function(input){
        input.addEventListener('change', updateVariant);
      });
      updateVariant();

      if(stickyAdd && form){
        stickyAdd.addEventListener('click', function(e){
          e.preventDefault();
          var submitButton = form.querySelector('[type="submit"]');
          if(submitButton) submitButton.click();
          else form.submit();
        });
      }

      function onScroll(){
        if(!sticky || !form) return;
        var rect = form.getBoundingClientRect();
        sticky.classList.toggle('show', rect.bottom < 0);
      }
      window.addEventListener('scroll', onScroll, { passive:true });
      window.addEventListener('resize', onScroll, { passive:true });
      onScroll();
    });
  }

  /* ---------- Cart page: quantity/remove ---------- */
  function setBusy(line, busy){
    if(!line) return;
    line.classList.toggle('is-busy', !!busy);
    line.querySelectorAll('button').forEach(function(btn){ btn.disabled = !!busy; });
  }

  function changeLine(key, quantity, line){
    if(!key) return;
    setBusy(line, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res){
      if(!res.ok) throw new Error('Cart update failed');
      return res.json();
    })
    .then(function(){ window.location.reload(); })
    .catch(function(){
      setBusy(line, false);
      window.location.href = '/cart';
    });
  }

  function initSoliaCart(){
    var root = document.querySelector('[data-solia-cart]');
    if(!root || root.dataset.soliaCartReady === 'true') return;
    root.dataset.soliaCartReady = 'true';

    root.addEventListener('click', function(e){
      var qtyBtn = e.target.closest('[data-solia-cart-qty]');
      var removeBtn = e.target.closest('[data-solia-cart-remove]');

      if(qtyBtn){
        e.preventDefault();
        var line = qtyBtn.closest('[data-solia-cart-line]');
        var key = line && line.getAttribute('data-key');
        var qtyNode = line && line.querySelector('[data-solia-cart-qty-val]');
        var current = parseInt(qtyNode ? qtyNode.textContent : '1', 10) || 1;
        var delta = parseInt(qtyBtn.getAttribute('data-solia-cart-qty'), 10) || 0;
        changeLine(key, Math.max(0, current + delta), line);
      }

      if(removeBtn){
        e.preventDefault();
        var removeLine = removeBtn.closest('[data-solia-cart-line]');
        var removeKey = removeLine && removeLine.getAttribute('data-key');
        changeLine(removeKey, 0, removeLine);
      }
    });
  }

  function init(){
    initSoliaPdp();
    initSoliaCart();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
